import * as _csRCL from './_csRcl';
import * as _hm from './_hm';
import * as _ht from './_ht';

import * as icv from './icv';

let $pageName = undefined as _ht.s | undefined;
let $pagez = {} as _ht.dz;

const _ngnz = _csRCL.grtAtom("ngnz", {
  pageName: undefined,
  pagez: {},
});

export const useNgnz = () => {
  const _dz = _csRCL.grtStt(_ngnz);
  const _setPageName = (
    pageName: _ht.s,
  ) => {
    $pageName = pageName;
    window.location.href = icv.appz.urlw + '/' + $pageName;
  }
  const _getPageName = () => {
    const _ls = String(window.location.href).split(`?`)[0].split(`/`);
    $pageName = _hm.f(_ls[3]) ? _ls[3] : undefined;
    return $pageName;
  }
  const _setPagez = (
    pagez: _ht.dz,
  ) => {
    $pagez = pagez;
  }
  const _getPagez = () => {
    return $pagez;
  }
  return {
    ... _dz,
    setPagez: _setPagez,
    getPagez: _getPagez,
    setPageName: _setPageName,
    getPageName: _getPageName,
  };
};

